import { RootState } from '../../../reducers'
import { currentBotMetadataSelector } from './currentBotMetadataSelector'

export function currentBotEnvironmentGroupIdSelector(state: RootState) {
  return currentBotMetadataSelector(state)?.environmentGroupId
}
